const initialState = {
	isLoading: false,
	byId: {},
	filteredProgramIds: [],
	categoriesById: {},
	filterSearch: '',
	filterCategory: '',
	filterPodcasts: ''
}

function getFilteredProgramsIds( programsById, filterSearch, filterCategory, filterPodcasts ) {
	let filteredProgramIds = []
	filterSearch = filterSearch.toLowerCase()

	if ( programsById ) {
		filteredProgramIds = Object.keys( programsById )
			.filter( id => {
				// Check podcasts:
				if ( filterPodcasts && 'true' !== programsById[ id ]['podcasts_enabled'] ) {
					return false
				}

				// Check type:
				if ( filterCategory && programsById[ id ]['categories'].indexOf( filterCategory ) === -1 ) {
					return false
				}

				// Check search term:
				if ( filterSearch ) {
					let title = programsById[ id ]['title'].toLowerCase()

					if ( title.indexOf( filterSearch ) === -1 ) {
						return false
					}
				}

				return true
			} )
	}

	return filteredProgramIds
}

export default function reducer( state = initialState, action ) {
	const { payload } = action
	let filteredProgramsById

	switch ( action.type ) {
		case 'REQUEST_PROGRAMS_DATA':
			return {
				...state,
				isLoading: true
			}

		case 'RECEIVE_PROGRAMS_DATA':
			return {
				...state,
				byId: payload.programs,
				filteredProgramIds: getFilteredProgramsIds( payload.programs, state.filterSearch, state.filterCategory, state.filterPodcasts ),
				categoriesById: payload.categories
			}

		case 'SET_PROGRAMS_FILTER_SEARCH':
			return {
				...state,
				filterSearch: payload,
				filteredProgramIds: getFilteredProgramsIds( state.byId, payload, state.filterCategory, state.filterPodcasts )
			}

		case 'SET_PROGRAMS_FILTER_CATEGORY':
			return {
				...state,
				filterCategory: payload,
				filteredProgramIds: getFilteredProgramsIds( state.byId, state.filterSearch, payload, state.filterPodcasts )
			}

		case 'SET_PROGRAMS_FILTER_PODCASTS':
			return {
				...state,
				filterPodcasts: payload,
				filteredProgramIds: getFilteredProgramsIds( state.byId, state.filterSearch, state.filterCategory, payload )
			}
	}

	return state
}
